import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, resolveImage } from "./api";

const DEFAULTS = {
  home_overline: "Outsourcing de Impressão & Automação",
  home_title_main: "Impressão sob controle.",
  home_title_accent: "Operação em alta performance.",
  home_subtitle:
    "Locação de impressoras, suprimentos e etiquetas personalizadas para empresas que querem reduzir custos, ganhar produtividade e ter um parceiro estratégico — não só um fornecedor.",
  home_cta_primary_text: "Locar Impressora",
  home_cta_primary_message: "Olá Avantech! Quero locar uma impressora. Pode me ajudar?",
  home_cta_secondary_text: "Ver Produtos",
  home_hero_image:
    "https://static.prod-images.emergentagent.com/jobs/1b35fc0a-0293-4ff8-ac55-1a277592b1f0/images/d4266e7b87213f41b5f244cb89dfaa55196b89445eeb6a04fe1ffc0ea682c4ce.png",
  cover_outsourcing:
    "https://images.unsplash.com/photo-1581092446327-9b52bd1570c2?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  cover_produtos:
    "https://customer-assets.emergentagent.com/job_avantech-solucoes/artifacts/jln3ea0y_side-view-employee-using-printer.jpg",
  cover_sobre:
    "https://customer-assets.emergentagent.com/job_avantech-solucoes/artifacts/c483pwvp_side-view-women-using-printer-work.jpg",
  cover_contato:
    "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
};

const Ctx = createContext({ settings: DEFAULTS, refresh: () => {} });

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = useCallback(async () => {
    try {
      const res = await api.get("/site/settings");
      setSettings({ ...DEFAULTS, ...res.data });
    } catch {
      /* keep defaults */
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return <Ctx.Provider value={{ settings, refresh }}>{children}</Ctx.Provider>;
};

export const useSiteSettings = () => useContext(Ctx);

/** Resolve a URL that may be /api/uploads/... to its absolute form */
export const settingImage = (url) => resolveImage(url);

export async function updateSiteSettings(updates) {
  const res = await api.put("/admin/site/settings", updates);
  return res.data;
}
